import { render, staticRenderFns } from "./zyxq.vue?vue&type=template&id=7c3146cc&scoped=true"
import script from "./zyxq.vue?vue&type=script&lang=js"
export * from "./zyxq.vue?vue&type=script&lang=js"
import style0 from "./zyxq.vue?vue&type=style&index=0&id=7c3146cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3146cc",
  null
  
)

export default component.exports